import { Box, FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CpdTextField from '@/components/ui/CpdTextField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../managedAccount.constants';

const PositivePayEncryptionSection = ({
  form,
  fieldErrors,
  onShouldEncryptChange,
  onFieldChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader>
        {t('managedAccounts.positivePay.encryption.title')}
      </SectionHeader>
      <Box sx={{ mb: SECTION_GRID_SPACING }}>
        <FormControlLabel
          control={
            <Switch
              name='should_encrypt'
              checked={form.should_encrypt}
              onChange={(_event, checked) => onShouldEncryptChange(checked)}
              disabled={disabled}
            />
          }
          label={t('managedAccounts.positivePay.encryption.shouldEncrypt')}
        />
        {fieldErrors.should_encrypt && (
          <Typography variant='caption' color='error' sx={{ display: 'block' }}>
            {fieldErrors.should_encrypt}
          </Typography>
        )}
      </Box>
      <Grid
        container
        spacing={SECTION_GRID_SPACING}
        sx={{ mb: SECTION_BOTTOM_MARGIN }}>
        {form.should_encrypt && (
          <Grid item xs={12}>
            <CpdTextField
              id='pgp_public_key'
              name='pgp_public_key'
              label={t('managedAccounts.positivePay.encryption.pgpPublicKey')}
              value={form.pgp_public_key}
              onChange={onFieldChange}
              error={Boolean(fieldErrors.pgp_public_key)}
              helperText={
                fieldErrors.pgp_public_key ||
                t('managedAccounts.positivePay.encryption.pgpPublicKeyRequired')
              }
              disabled={disabled}
              required
              multiline
              minRows={5}
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 0 }}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default PositivePayEncryptionSection;
